import isEmpty from 'ramda/src/isEmpty'
import { formStoreLenses } from 'root/src/client/logic/form/lenses'

const { viewFormSubmitError } = formStoreLenses

export default (state, { moduleKey }) => {
	const error = viewFormSubmitError(moduleKey, state)
	return isEmpty(error) ? undefined : error
}
